import zhCN from './json/red-envelope.zh_CN.json';
import zhTW from './json/red-envelope.zh_TW.json';
import en from './json/red-envelope.en.json';
import ja from './json/red-envelope.ja.json';
import ko from './json/red-envelope.ko.json';
import ru from './json/red-envelope.ru.json';
export default {
  zh_CN: zhCN,
  zh_TW: zhTW,
  en,
  ja,
  ko,
  ru
};
